export default __webpack_public_path__ + "static/ds-zeroheight-lapierre-product-line-hero-a822afdf830bb0a767e5fe3161787b10.png";